import { Button } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Col, Row } from 'reactstrap';

import { useDebtLoader } from './DebtLoader';

const keyPrefix = 'financialPortal.currentAccount.tabs.currentAccount';

interface DebtActionRowProps {
  onOpenNewChargeModal?: () => void;
  onOpenNewRefundModal?: () => void;
}

/**
 * Action row rendered between the filters and the table.
 *
 * Left side: "En mora" chip (red badge) with overdue count.
 * Right side: "+ INGRESAR DEVOLUCION" (disabled) and "+ INGRESAR NUEVO CARGO" buttons.
 */
export default function DebtActionRow({
  onOpenNewChargeModal,
  onOpenNewRefundModal,
}: DebtActionRowProps) {
  const { t } = useTranslation();
  const { data } = useDebtLoader();

  const overdueCount = useMemo(() => {
    return (data?.debts ?? []).filter((d) => (d.daysLate ?? 0) > 0).length;
  }, [data]);

  return (
    <Row className="align-items-center mt-3">
      {/* Left: overdue chip */}
      <Col xs={12} md={6} className="mb-2 mb-md-0">
        {overdueCount > 0 && (
          <Badge
            className="fs-14 fw-500 py-2 px-3"
            style={{
              backgroundColor: '#F8C6C6',
              color: '#9B1C1C',
            }}
            pill
          >
            {t(`${keyPrefix}.actionRow.overdue`)} ({overdueCount})
          </Badge>
        )}
      </Col>

      {/* Right: action buttons */}
      <Col xs={12} md={6}>
        <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
          <Button
            type="button"
            text={t(`${keyPrefix}.header.actions.newRefund`)}
            size="md"
            icon="plus"
            outlined
            onClick={() => onOpenNewRefundModal?.()}
          />
          <Button
            type="button"
            text={t(`${keyPrefix}.header.actions.newCharge`)}
            size="md"
            icon="plus"
            outlined
            onClick={() => onOpenNewChargeModal?.()}
          />
        </div>
      </Col>
    </Row>
  );
}
